import type { IconSetDefinitions } from '@hotjar/webapp/../../../hotsauce/build/components/Icon/icons';
import type { HighlightType } from '@hotjar/webapp/domains/highlights/model';
import { GenericShortListFilter } from '@hotjar/global-filters';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FiltersState } from './use-filter-state';
import { SOURCES_CONFIG } from './use-filter-state';

interface SourceFilterProps {
  onApply: (source: FiltersState['sources']) => void;
  sources: FiltersState['sources'];
}

export function SourceFilter({ sources, onApply }: SourceFilterProps): JSX.Element {
  const { t } = useTranslation();
  const [currentValue, setCurrentValue] = useState(sources);

  // reset the current values after route change
  useEffect(() => {
    setCurrentValue(sources);
  }, [setCurrentValue, sources]);

  const options = SOURCES_CONFIG.map((x) => ({
    value: x.value,
    label: t(x.labelKey),
    icon: x.icon as keyof IconSetDefinitions,
  }));

  const onChange = (value?: HighlightType[]) => {
    setCurrentValue(value ?? []);
    onApply(value ?? []);
  };

  const onRemove = () => onChange([]);

  return (
    <GenericShortListFilter
      filterName={t('highlights:filters.sources.filter-name')}
      label2={currentValue.length ? undefined : 'Any'}
      iconName="chart_multiple"
      currentValue={currentValue}
      onRemove={currentValue.length ? onRemove : undefined}
      isInactive={currentValue.length === 0}
      optionList={options}
      showDropdownCaret
      onApply={onChange}
    />
  );
}
